import React from 'react'
import { Redirect } from 'react-router-dom'
import Dialog from 'material-ui-legacy/Dialog'
import Snackbar from 'material-ui-legacy/Snackbar'

import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import DoneButton from '../UI/DoneButton'
import ServiceForm from './ServiceForm'
import { ServiceCard } from './ServiceCard'

import Resource from '../../stores/resource'
const ServiceStore = Resource('services')

class NewService extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      service: this.props.attributes || {},
      saved: false,
      error: '',
      snackbarMessage: '',
      redirect: null
    }
  }

  _save = attributes => {
    // Adjust attributes
    delete attributes.serviceCategoryName
    delete attributes.serviceCategoryFormattedName
    delete attributes.costFormulaName
    delete attributes.rateFormulaName
    // Create!
    ServiceStore.create(attributes)
      .then(result => {
        this.setState(
          {
            saved: true,
            error: '',
            savedService: result.data.data,
            snackbarMessage: `Service "${attributes.name}" created!`
          },
          () => {
            if (this.props.savedCallback) {
              this.props.savedCallback(this.state.savedService)
            }
          }
        )
      })
      .catch(error => {
        this.setState({
          saved: false,
          error: errors.unpack(error)
        })
      })
  }

  _closeErrorDialog = () => this.setState({ error: '' })

  _closeSuccessDialog = () => this.setState({ redirect: `/services` })

  _resetSnackbar = () => this.setState({ snackbarMessage: '' })

  _redirectTo = url => this.setState({ redirect: url })

  render() {
    if (this.state.redirect) return <Redirect push to={this.state.redirect} />

    const service = this.state.service
    const saved = this.state.saved

    const successDialogActions = [
      <DoneButton onTouchTap={this._closeSuccessDialog} />
    ]

    return (
      <section>
        <ServiceForm
          formTitle={this.props.formTitle}
          serviceCategoryId={service.serviceCategoryId}
          serviceCategoryName={service.serviceCategoryFormattedName}
          name={service.name}
          description={service.description}
          rate={service.rate}
          cost={service.cost}
          rateUnit={service.rateUnit}
          costFormulaName={service.costFormulaName}
          costFormulaId={service.costFormulaId}
          rateFormulaName={service.rateFormulaName}
          rateFormulaId={service.rateFormulaId}
          notes={service.notes}
          forceChanged={this.props.forceChanged}
          submitCallback={this._save}
          cancelCallback={this.props.cancelCallback}
        />

        <ErrorDialog
          open={Boolean(this.state.error)}
          closeCallback={this._closeErrorDialog}
          title="Couldn't create service"
        >
          <p>
            <strong>Error:</strong> {this.state.error}
          </p>
        </ErrorDialog>

        <Snackbar
          open={Boolean(this.state.snackbarMessage)}
          message={this.state.snackbarMessage}
          autoHideDuration={4000}
          onRequestClose={this._resetSnackbar}
        />

        {/* Success dialog */}
        {saved &&
          this.props.showSuccessDialog && (
            <Dialog
              actions={successDialogActions}
              modal={false}
              onRequestClose={this._closeSuccessDialog}
              open={Boolean(this.state.saved)}
              title="Service created"
            >
              <p>
                A new service has been created with the information below.<br />
                If you see any incorrect information, press the{' '}
                <strong>Edit</strong> button.
              </p>
              <ServiceCard
                service={this.state.savedService}
                editCallback={() =>
                  this._redirectTo(
                    `/services/${this.state.savedService.id}/edit`
                  )
                }
              />
            </Dialog>
          )}
      </section>
    )
  }
}

export default NewService



// WEBPACK FOOTER //
// ./src/components/Services/NewService.jsx